import IMG_1_1 from 'assets/images/scooter/mix/img-mix-1.png'
import IMG_1_2 from 'assets/images/scooter/mix/img-mix-1_m.png'

import IMG_2_1 from 'assets/images/scooter/mix/img-mix-2.png'
import IMG_2_2 from 'assets/images/scooter/mix/img-mix-2_m.png'

import IMG_3_1 from 'assets/images/scooter/mix/img-mix-3.png'
import IMG_3_2 from 'assets/images/scooter/mix/img-mix-3_m.png'

import IMG_4_1 from 'assets/images/scooter/mix/img-mix-4.png'
import IMG_4_2 from 'assets/images/scooter/mix/img-mix-4_m.png'

import IMG_5_1 from 'assets/images/scooter/mix/img-mix-5.png'
import IMG_5_2 from 'assets/images/scooter/mix/img-mix-5_m.png'

import IMG_6_1 from 'assets/images/scooter/mix/img-mix-6.png'
import IMG_6_2 from 'assets/images/scooter/mix/img-mix-6_m.png'

import IMG_7_1 from 'assets/images/scooter/mix/img-mix-7.png'
import IMG_7_2 from 'assets/images/scooter/mix/img-mix-7_m.png'

import IMG_8_1 from 'assets/images/prev_arrow.svg'
import IMG_8_2 from 'assets/images/next_arrow.svg'

import IMG_9_1 from 'assets/images/scooter/mix/img-mix-8.png'
import IMG_9_2 from 'assets/images/scooter/mix/img-mix-8_m.png'

import IMG_10_1 from 'assets/images/scooter/mix/img-mix-9.png'
import IMG_10_2 from 'assets/images/scooter/mix/img-mix-9_m.png'
import IMG_10_3 from 'assets/images/scooter/mix/img-mix-10.png'
import IMG_10_4 from 'assets/images/scooter/mix/img-mix-10_m.png'
import IMG_10_5 from 'assets/images/scooter/mix/img-mix-11.png'
import IMG_10_6 from 'assets/images/scooter/mix/img-mix-11_m.png'
import IMG_10_7 from 'assets/images/scooter/mix/img-mix-12.png'
import IMG_10_8 from 'assets/images/scooter/mix/img-mix-12_m.png'

import IMG_11_1 from 'assets/images/scooter/mix/img-mix-13.png'
import IMG_11_2 from 'assets/images/scooter/mix/img-mix-13_m.png'

import IMG_12_1 from 'assets/images/scooter/mix/img-mix-14.png'
import IMG_12_2 from 'assets/images/scooter/mix/img-mix-14_m.png'
import IMG_12_3 from 'assets/images/scooter/mix/img-mix-15.png'
import IMG_12_4 from 'assets/images/scooter/mix/img-mix-15_m.png'
import IMG_12_5 from 'assets/images/scooter/mix/img-mix-16.png'
import IMG_12_6 from 'assets/images/scooter/mix/img-mix-16_m.png'
import IMG_12_7 from 'assets/images/scooter/mix/img-mix-17.png'
import IMG_12_8 from 'assets/images/scooter/mix/img-mix-17_m.png'

import IMG_13_1 from 'assets/images/scooter/mix/img-mix-18_1.png'
import IMG_13_2 from 'assets/images/scooter/xl/img-xl-13_m.png'

import IMG_15_1 from 'assets/images/scooter/mix/img-mix-19.png'
import IMG_15_2 from 'assets/images/scooter/mix/img-mix-20.png'
import IMG_15_3 from 'assets/images/scooter/mix/img-mix-21.png'

import { URL, OUTER_URL } from '../../utils/Utils'
import ScooterMixImgSwiper from '../../components/swiper/ScooterMixImgSwiper'
import './ScooterMix.scss'

/**
 * @file 고고로 2 VIVA MIX 화면
 */
function ScooterMix() {
    return (
        <>
            <div className="mix-one pc" style={{ backgroundImage: `url(${IMG_1_1})` }} />
            <div className="mix-one mobile" style={{ backgroundImage: `url(${IMG_1_2})` }} />
            <div className="mix-two">
                <div>
                    <div className="t1">고고로 비바 믹스</div>
                    <a className="link" href="" onClick={() => window.open(OUTER_URL.GOGORO_HOMPAGE)}>
                        구매문의
                    </a>
                </div>
            </div>
            <div className="mix-three">
                <div className="text">
                    고고로 VIVA MIX <br />
                    스타일리시한 사람들을 위해
                    <br />
                    <br />
                    다양한 스타일로
                    <br />
                    매일 색다른 주행
                </div>
            </div>
            <div className="mix-four pc" style={{ backgroundImage: `url(${IMG_2_1})` }} />
            <div className="mix-four mobile" style={{ backgroundImage: `url(${IMG_2_2})` }} />
            <div className="mix-five pc" style={{ backgroundImage: `url(${IMG_3_1})` }}>
                <div className="text-box">
                    <div className="sub">매일 다니던 길도 새롭게</div>
                    <div className="t1">
                        원하는 곳 어디든 바로 떠나보세요
                        <br />
                    </div>
                </div>
            </div>
            <div className="mix-five mobile" style={{ backgroundImage: `url(${IMG_3_2})` }}>
                <div className="text-box">
                    <div className="sub">매일 다니던 길도 새롭게</div>
                    <div className="t1">
                        원하는 곳 어디든 바로 떠나보세요
                        <br />
                    </div>
                </div>
            </div>

            <div className="mix-six">
                <div className="t1">편안한 핸들링</div>
                <div className="grid-box">
                    <div>
                        <div className="one img">
                            <img className="pc" src={IMG_4_1} alt="" />
                            <img className="mobile" src={IMG_4_2} alt="" />
                            <div className="text-box">
                                {/* <div className="sub">날렵한 스마트 스쿠터</div> */}
                                <div className="t1">
                                    어떤 도로 환경에서도
                                    <br />
                                    편리한 운행이 가능합니다.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="two img">
                            <img className="pc" src={IMG_5_1} alt="" />
                            <img className="mobile" src={IMG_5_2} alt="" />
                            <div className="text-box">
                                <div className="sub">FLO DRIVE™ belt transmission*</div>
                                <div className="t1">
                                    FLO DRIVE 기술을 적용하여
                                    <br />
                                    부드럽고 조용한
                                    <br />
                                    승차감을 제공합니다
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="three img">
                            <img className="pc" src={IMG_6_1} alt="" />
                            <img className="mobile" src={IMG_6_2} alt="" />
                            <div className="text-box">
                                <div className="sub">Here to mix it up</div>
                                <div className="t1">
                                    사운드 악세서리에서 <br />
                                    자유롭게 리믹스하고 <br />
                                    플레이 하세요
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mix-seven">
                <div className="img pc" style={{ backgroundImage: `url(${IMG_7_1})` }} />
                <div className="img mobile" style={{ backgroundImage: `url(${IMG_7_2})` }} />
                <div className="text-box">
                    {/* <div className="sub">실용적인 기능 그이상</div> */}
                    <div className="t1">
                        안전과 편안함을
                        <br />
                        모두 생각했습니다
                    </div>
                </div>
            </div>

            <div className="mix-eight">
                <div className="t1">사소한 디테일에서부터 나오는 편리함</div>
                <div className="swiper-outer">
                    <button className="slide-control-btn prev">
                        <img src={IMG_8_1} alt="" />
                    </button>
                    <button className="slide-control-btn next">
                        <img src={IMG_8_2} alt="" />
                    </button>
                    <ScooterMixImgSwiper />
                </div>
            </div>

            <div className="mix-nine">
                <div className="img pc" style={{ backgroundImage: `url(${IMG_9_1})` }} />
                <div className="img mobile" style={{ backgroundImage: `url(${IMG_9_2})` }} />
                <div className="text-box">
                    <div className="sub">자유로운 스타일의 표현</div>
                    <div className="t1">
                        다채로운 컬러로 표현하는
                        <br />
                        나만의 스타일
                    </div>
                </div>
            </div>

            <div className="mix-ten">
                <div className="t1 pc">취향대로 꾸미는 나만의 스쿠터</div>
                <div className="t1 mobile">
                    예상 밖의 방식으로 <br />
                    스타일과 악세서리를 <br />
                    변경해보세요.
                </div>
                <div className="grid-box">
                    <div>
                        <div className="one img pc" style={{ backgroundImage: `url(${IMG_10_1})` }}>
                            <div className="text-box">
                                <div className="sub">타원형 헤드라이트</div>
                                <div className="t1">
                                    중앙 전면에 배치된 <br />
                                    고고로의 상징적인 디자인
                                </div>
                            </div>
                        </div>
                        <div className="one img mobile" style={{ backgroundImage: `url(${IMG_10_2})` }}>
                            <div className="text-box">
                                <div className="sub">타원형 헤드라이트</div>
                                <div className="t1">
                                    중앙 전면에 배치된 <br />
                                    고고로의 상징적인 디자인
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="two img pc" style={{ backgroundImage: `url(${IMG_10_3})` }}>
                            <div className="text-box">
                                <div className="sub">비스듬한 LED 테일라이트</div>
                                <div className="t1">
                                    독특한 차체 구조를 강조하는 <br />
                                    조명 설계
                                </div>
                            </div>
                        </div>
                        <div className="two img mobile" style={{ backgroundImage: `url(${IMG_10_4})` }}>
                            <div className="text-box">
                                <div className="sub">비스듬한 LED 테일라이트</div>
                                <div className="t1">
                                    독특한 차체 구조를 강조하는 <br />
                                    조명 설계
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="three img pc" style={{ backgroundImage: `url(${IMG_10_5})` }}>
                            <div className="text-box">
                                <div className="sub">사운드 표현</div>
                                <div className="t1">
                                    내 취향에 맞는 사운드를
                                    <br />
                                    자유롭게 설정해보세요
                                </div>
                            </div>
                        </div>
                        <div className="three img mobile" style={{ backgroundImage: `url(${IMG_10_6})` }}>
                            <div className="text-box">
                                <div className="sub">사운드 표현</div>
                                <div className="t1">
                                    내 취향에 맞는 사운드를
                                    <br />
                                    자유롭게 설정해보세요
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="four img pc" style={{ backgroundImage: `url(${IMG_10_7})` }}>
                            <div className="text-box">
                                <div className="sub">POP accessory system</div>
                                <div className="t1">틀에서 벗어난 나만의 커스텀</div>
                            </div>
                        </div>
                        <div className="four img mobile" style={{ backgroundImage: `url(${IMG_10_8})` }}>
                            <div className="text-box">
                                <div className="sub">POP accessory system</div>
                                <div className="t1">틀에서 벗어난 나만의 커스텀</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mix-eleven">
                <div className="img pc" style={{ backgroundImage: `url(${IMG_11_1})` }} />
                <div className="img mobile" style={{ backgroundImage: `url(${IMG_11_2})` }} />
                <div className="text-box">
                    <div className="sub">Simple Is Best</div>
                    <div className="t1">더 간편하고 직관적으로</div>
                </div>
            </div>

            <div className="mix-twelve">
                <div className="grid-box">
                    <div>
                        <div className="one img pc" style={{ backgroundImage: `url(${IMG_12_1})` }}>
                            <div className="text-box">
                                <div className="sub">높은 품질의 카본 벨트</div>
                                <div className="t1">
                                    Gate 카본 벨트는 오일이 <br />
                                    필요없고 내구성이 뛰어납니다.
                                </div>
                            </div>
                        </div>
                        <div className="one img mobile" style={{ backgroundImage: `url(${IMG_12_2})` }}>
                            <div className="text-box">
                                <div className="sub">높은 품질의 카본 벨트</div>
                                <div className="t1">
                                    Gate 카본 벨트는 오일이 <br />
                                    필요없고 내구성이 뛰어납니다.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="two img pc" style={{ backgroundImage: `url(${IMG_12_3})` }}>
                            <div className="text-box">
                                <div className="sub">Simple, keyless</div>
                                <div className="t1">
                                    스마트 키를 사용해
                                    <br />
                                    터치 한번으로 출발하세요
                                </div>
                            </div>
                        </div>
                        <div className="two img mobile" style={{ backgroundImage: `url(${IMG_12_4})` }}>
                            <div className="text-box">
                                <div className="sub">Simple, keyless</div>
                                <div className="t1">
                                    스마트 키를 사용해
                                    <br />
                                    터치 한번으로 출발하세요
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="three img pc" style={{ backgroundImage: `url(${IMG_12_5})` }}>
                            <div className="text-box">
                                <div className="sub">Smart, for the future</div>
                                <div className="t1">
                                    근접 잠금 해제, 음소거 모드 <br />
                                    날씨 기반의 파워 튜닝까지
                                </div>
                            </div>
                        </div>
                        <div className="three img mobile" style={{ backgroundImage: `url(${IMG_12_6})` }}>
                            <div className="text-box">
                                <div className="sub">Smart, for the future</div>
                                <div className="t1">
                                    근접 잠금 해제, 음소거 모드 <br />
                                    날씨 기반의 파워 튜닝까지
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="four img pc" style={{ backgroundImage: `url(${IMG_12_7})` }}>
                            <div className="text-box">
                                <div className="sub">Unique sound effects</div>
                                <div className="t1">
                                    내 취향에 맞게 설정하는
                                    <br />
                                    나만의 사운드
                                </div>
                            </div>
                        </div>
                        <div className="four img mobile" style={{ backgroundImage: `url(${IMG_12_8})` }}>
                            <div className="text-box">
                                <div className="sub">Unique sound effects</div>
                                <div className="t1">
                                    내 취향에 맞게 설정하는
                                    <br />
                                    나만의 사운드
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mix-fourteen pc" style={{ backgroundImage: `url(${IMG_13_1})` }}></div>
            <div className="mix-fourteen mobile" style={{ backgroundImage: `url(${IMG_13_2})` }}></div>

            <div className="mix-fifteen">
                <div className="mix-motors-wrapper">
                    <img src={IMG_15_1} alt="" />
                    <img src={IMG_15_2} alt="" />
                    <img src={IMG_15_3} alt="" />
                    <div className="t1">고고로 비바 MIX</div>
                    <div className="sub">BELT</div>
                    <div className="colors">
                        <span style={{ backgroundColor: '#ddb1f9' }} />
                        <span style={{ backgroundColor: '#ffdc2e' }} />
                        <span style={{ backgroundColor: '#fff' }} />
                    </div>
                </div>
                <div className="details">
                    <div className="t1">디테일</div>
                    <div className="details-box">
                        <div>
                            <div className="box-row">
                                <div className="s1">길이 x 너비 x 높이 (백미러 제외)</div>
                                <div className="d1">1,770 x 725 x 1,093mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">휠베이스</div>
                                <div className="d1">1,235mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">안장 높이</div>
                                <div className="d1">745mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">무게 (비어 있음/배터리 포함)</div>
                                <div className="d1">94/112kg</div>
                            </div>
                        </div>
                        <div>
                            <div className="box-row">
                                <div className="s1">최대 전력</div>
                                <div className="d1">6.0kW @3,000rpm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">최대 토크 (모터/휠)</div>
                                <div className="d1">24 / 178Nm @ 0-2,500rpm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">등판성</div>
                                <div className="d1">
                                    30%(17°): 30km/h <br />
                                    20%(11°): 40km/h <br />
                                    10%(6°): 60km/h <br />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="extra-describes">
                        * 이 표는 참고용이며 테스트 시나리오에 따라 결과가 달라질 수 있습니다.
                        <br />* 자세한 정보는 고객센터를 통해 확인해주시기 바랍니다.
                    </div>
                </div>
            </div>
        </>
    )
}

export default ScooterMix
